import React, { createContext, useContext, useState } from "react";

const AdminTokenContext = createContext({ token: "", setToken: () => {} });

export const AdminTokenProvider = ({ children }) => {
  const [token, setToken] = useState("");
  return (
    <AdminTokenContext.Provider value={{ token, setToken }}>
      {children}
    </AdminTokenContext.Provider>
  );
};

export const useAdminToken = () => useContext(AdminTokenContext);
